"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVKExternalInput = void 0;
var AVKExternalInputPosition_1 = require("./AVKExternalInputPosition");
var AVKExternalInputShift_1 = require("./AVKExternalInputShift");
var NModel_1 = require("./NModel");
var AVKExternalInput = /** @class */ (function (_super) {
    __extends(AVKExternalInput, _super);
    function AVKExternalInput(id, inputName, isAutoCrop, zoomLevel) {
        var _this = _super.call(this) || this;
        _this._id = ''; // "AV.IO 4K HD"
        _this._inputName = ''; // "Input 1"
        _this._zoomLevel = 0.4;
        _this._isAutoCrop = true; // TODO: is true okay to be set as default here
        _this._id = id;
        _this._inputName = inputName;
        _this._isAutoCrop = isAutoCrop;
        _this._zoomLevel = zoomLevel;
        _this._position = new AVKExternalInputPosition_1.AVKExternalInputPosition();
        _this._shift = new AVKExternalInputShift_1.AVKExternalInputShift();
        return _this;
    }
    AVKExternalInput.universalModelType = function () {
        return 'io.avail.models.externalInput.v1';
    };
    Object.defineProperty(AVKExternalInput.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVKExternalInput.prototype, "inputName", {
        get: function () {
            return this._inputName;
        },
        set: function (value) {
            this._inputName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVKExternalInput.prototype, "position", {
        get: function () {
            return this._position;
        },
        set: function (value) {
            this._position = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVKExternalInput.prototype, "shift", {
        get: function () {
            return this._shift;
        },
        set: function (value) {
            this._shift = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVKExternalInput.prototype, "zoomLevel", {
        get: function () {
            return this._zoomLevel;
        },
        set: function (value) {
            this._zoomLevel = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVKExternalInput.prototype, "isAutoCrop", {
        get: function () {
            return this._isAutoCrop;
        },
        set: function (value) {
            this._isAutoCrop = value;
        },
        enumerable: false,
        configurable: true
    });
    return AVKExternalInput;
}(NModel_1.NModel));
exports.AVKExternalInput = AVKExternalInput;
//# sourceMappingURL=AVKExternalInput.js.map